export default __webpack_public_path__ + "static/screenFourthSectionUkBig-ae86995d5713384bd661e0b5df78256e.webp";